export default __webpack_public_path__ + "static/media/Img_Profile.43b500ef.png";